<template>
    <ion-page class="ion-page"
              id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <router-link :to="{ name: 'home' }">
                        <ion-button>
                            <ion-icon md="arrow-back"
                                      ios="arrow-back"
                                      slot="start"/>

                            {{ $t('ncrypt.back') }}
                        </ion-button>
                    </router-link>
                </ion-buttons>
            </template>

            <template>
                <ion-title v-show="!$root.isMobileOrSmall">
                    {{ $t('ncrypt.register_page.title') }}
                </ion-title>
            </template>
        </default-header>

        <ion-content class="bg-image"
                     fullscreen>
            <background slot="fixed"/>

            <flash-messages/>

            <register/>
        </ion-content>
    </ion-page>
</template>

<script>
    import Register from "../../components/auth/Register";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import Background from "../Background";

    export default {
        components: {Background, DefaultHeader, FlashMessages, Register},
    }
</script>
